import { HTTPStatusCodes } from '@omnipresentgroup/constants';
import { HttpResponse, http } from 'msw';

import {
  XERO_INTEGRATION_API_PATH,
  XERO_INTEGRATION_CONNECTION_PATH,
  XERO_INTEGRATION_ORGANISATIONS_PATH,
  XERO_INTEGRATION_XERO_ACCOUNT_CODE_MAPPINGS_PATH,
  XERO_INTEGRATION_XERO_ACCOUNTS_PATH,
} from './constants';
import {
  DEFAULT_INTEGRATION_RESPONSE,
  DEFAULT_MERGE_LINK_DEFAULT_RESPONSE,
  DEFAULT_UPDATE_XERO_ACCOUNT_CODE_MAPPINGS_RESPONSE,
  DEFAULT_XERO_ACCOUNT_CODE_MAPPINGS_RESPONSE,
  DEFAULT_XERO_ACCOUNTS_RESPONSE,
  DEFAULT_XERO_CONNECTION_RESPONSE,
  DEFAULT_XERO_ORGANISATIONS_RESPONSE,
} from './fixtures';
import {
  CREATE_MERGE_INTEGRATION_LINK_PATH,
  INTEGRATION_STATUS_PATH,
} from './hooks';

export const integrationsHandlers = [
  http.get(`*${INTEGRATION_STATUS_PATH}`, () =>
    HttpResponse.json(DEFAULT_INTEGRATION_RESPONSE, {
      status: HTTPStatusCodes.OK,
    }),
  ),
  http.post(`*${CREATE_MERGE_INTEGRATION_LINK_PATH}`, () =>
    HttpResponse.json(DEFAULT_MERGE_LINK_DEFAULT_RESPONSE, {
      status: HTTPStatusCodes.OK,
    }),
  ),
  http.get(
    `*${XERO_INTEGRATION_API_PATH}/:clientId/${XERO_INTEGRATION_CONNECTION_PATH}`,
    () =>
      HttpResponse.json(DEFAULT_XERO_CONNECTION_RESPONSE, {
        status: HTTPStatusCodes.OK,
      }),
  ),
  http.delete(
    `*${XERO_INTEGRATION_API_PATH}/:clientId/${XERO_INTEGRATION_CONNECTION_PATH}`,
    () =>
      HttpResponse.json(
        {},
        {
          status: HTTPStatusCodes.OK,
        },
      ),
  ),
  http.patch(
    `*${XERO_INTEGRATION_API_PATH}/:clientId/${XERO_INTEGRATION_CONNECTION_PATH}`,
    () =>
      HttpResponse.json(DEFAULT_XERO_CONNECTION_RESPONSE, {
        status: HTTPStatusCodes.OK,
      }),
  ),
  http.get(
    `*${XERO_INTEGRATION_API_PATH}/:clientId/${XERO_INTEGRATION_ORGANISATIONS_PATH}`,
    () =>
      HttpResponse.json(DEFAULT_XERO_ORGANISATIONS_RESPONSE, {
        status: HTTPStatusCodes.OK,
      }),
  ),
  http.get(
    `*${XERO_INTEGRATION_API_PATH}/:clientId/${XERO_INTEGRATION_XERO_ACCOUNTS_PATH}`,
    () =>
      HttpResponse.json(DEFAULT_XERO_ACCOUNTS_RESPONSE, {
        status: HTTPStatusCodes.OK,
      }),
  ),
  http.get(
    `*${XERO_INTEGRATION_API_PATH}/:clientId/${XERO_INTEGRATION_XERO_ACCOUNT_CODE_MAPPINGS_PATH}`,
    () =>
      HttpResponse.json(DEFAULT_XERO_ACCOUNT_CODE_MAPPINGS_RESPONSE, {
        status: HTTPStatusCodes.OK,
      }),
  ),
  http.patch(
    `*${XERO_INTEGRATION_API_PATH}/:clientId/${XERO_INTEGRATION_XERO_ACCOUNT_CODE_MAPPINGS_PATH}`,
    () =>
      HttpResponse.json(DEFAULT_UPDATE_XERO_ACCOUNT_CODE_MAPPINGS_RESPONSE, {
        status: HTTPStatusCodes.MULTI_STATUS,
      }),
  ),
];
